<template>
    <v-container class="pa-0">
        <!-- Card do perfil do usuário -->
        <v-row justify="center" align="center" style="background-color: #f2f2f2;">
            <v-col cols="12" md="5">
                <v-card outlined
                    style="justify-content: center; align-items: center; display: flex; background-color: transparent; border: none;">
                    <v-card-text class="pa-6">
                        <div class="d-flex align-center mb-4" style="gap: 16px;">
                            <div class="avatar-container" style="position: relative;">
                                <v-avatar 
                                    size="120" 
                                    class="profile-avatar"
                                >
                                    <v-img 
                                        :src="user.avatar !== null ? `https://api.mylegis.com.br/assets/${user.avatar}` : require(`../assets/icon-person.svg`)" 
                                        cover
                                        alt="Foto de perfil"
                                    />
                                </v-avatar>
                                <!-- Overlay para edição de foto -->
                                <div 
                                    v-if="!disabledCondition" 
                                    class="avatar-overlay"
                                    @click="triggerFileInput"
                                >
                                    <v-icon color="white" size="32">mdi-camera</v-icon>
                                    <span class="overlay-text">Alterar foto</span>
                                </div>
                                <input 
                                    ref="fileInput"
                                    type="file"
                                    accept="image/*"
                                    style="display: none;"
                                    @change="handleFileSelect"
                                />
                            </div>
                            <div>
                                <h2 class="text-h4 mb-1">{{ user.first_name }} {{ user.last_name }}</h2>
                                <p class="text-h6 mb-2" style="color: #666;">{{ user.plano | plan }}</p>
                                <v-btn 
                                    @click="disabledCondition = !disabledCondition" 
                                    color="#F15A24" 
                                    dark 
                                    small
                                >
                                    <v-icon class="mr-1">mdi-pencil</v-icon>
                                    {{ disabledCondition ? 'Editar perfil' : 'Cancelar edição' }}
                                </v-btn>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="4" style="justify-content: center; align-items: center; display: flex;">
                <!-- Card de utilização do plano -->
                <v-card outlined style="border: 2px dashed #ccc;  background-color: transparent;">
                    <v-card-text class="pa-4">
                        <h3 class="text-h6 font-weight-bold mb-3">Utilização do plano</h3>
                        <p class="text-body-1 mb-3">{{ sizeFiles | filesize }} de {{ maxStorage | filesize }}</p>
                        <v-progress-linear :value="sizeFilesPercent" color="#F15A24" height="8"
                            rounded></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="3" style="justify-content: center; align-items: center; display: flex;">
                <PaymentDialog :reloadSub="getUserLoggedPayments" :address="address" />
            </v-col>
        </v-row>

        <v-row>
            <!-- Formulário de informações pessoais -->
            <v-col cols="12">
                <v-card outlined style="border: none;">
                    <v-card-title class="pa-4">
                        <h3 class="text-h5 ">Informações Pessoais</h3>
                    </v-card-title>
                    <v-card-text class="pa-4">
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="first_name" :counter="30" :disabled="disabledCondition"
                                        :rules="nameRules" label="Nome" color="#F15A24" outlined dense
                                        required></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="nickname" :counter="30" :disabled="disabledCondition"
                                        :rules="nameRules" label="Apelido" color="#F15A24" outlined dense
                                        required></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="email" :rules="emailRules" :disabled="true" label="E-mail"
                                        color="#F15A24" outlined dense required></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="tags" color="#F15A24" label="Escritório / Instituição"
                                        outlined dense required></v-text-field>
                                </v-col>
                            </v-row>

                            <v-btn v-if="!disabledCondition" @click="updateUser()" color="#F15A24" dark large
                                class="mt-4">
                                <v-icon class="mr-2">mdi-content-save</v-icon>
                                Salvar
                            </v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
            <!-- Formulário de endereço -->
            <v-col cols="12">
                <v-card outlined style="border: none;" class="mt-6">
                    <v-card-title class="pa-4">
                        <h3 class="text-h5 ">Endereço</h3>
                    </v-card-title>
                    <v-card-text class="pa-4">
                        <v-form ref="addressForm" v-model="valid" lazy-validation>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field color="#F15A24" @blur="buscaCEP" v-mask="'#####-###'"
                                        v-model="address.cep" :disabled="disabledCondition" :rules="nameRules"
                                        label="CEP" outlined dense required>
                                        <template v-slot:append-outer>
                                            <v-progress-circular v-if="loadingCEP" indeterminate
                                                :size="25"></v-progress-circular>
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field color="#F15A24" :disabled="disabledCondition" v-model="address.estado"
                                        :rules="nameRules" label="Estado" outlined dense required />
                                </v-col>
                            </v-row>

                            <v-text-field color="#F15A24" :disabled="disabledCondition" v-model="address.cidade"
                                label="Cidade" outlined dense required />

                            <v-text-field color="#F15A24" :disabled="disabledCondition" v-model="address.bairro"
                                label="Bairro" outlined dense required />

                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field color="#F15A24" :disabled="disabledCondition" v-model="address.rua"
                                        :rules="nameRules" label="Rua" outlined dense required />
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field color="#F15A24" :disabled="disabledCondition" v-model="address.numero"
                                        :rules="nameRules" label="Número" outlined dense required />
                                </v-col>
                            </v-row>

                            <v-text-field color="#F15A24" :disabled="disabledCondition" v-model="address.complemento"
                                label="Complemento" outlined dense />

                            <v-btn v-if="!disabledCondition" @click="postAddress" color="#F15A24" dark large
                                class="mt-4">
                                <v-icon class="mr-2">mdi-content-save</v-icon>
                                Salvar
                            </v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- Coluna direita - Informações do plano (se necessário) -->
            <!-- <v-col cols="12" md="4">
                <div v-if="showPagamento">
                    <h5 class="mb-4">Meu Plano</h5>

                    <v-card v-if="subscriptions.length == 0" class="mb-4">
                        <v-card-title>Nova Assinatura</v-card-title>
                        <v-card-text class="d-flex align-center justify-center flex-column">
                            <p class="text-center mb-4">
                                Você ainda não possui uma assinatura ativa. Para iniciar, clique no botão abaixo e
                                selecione
                                o plano
                                desejado.
                            </p>
                            <PaymentDialog :reloadSub="getUserLoggedPayments" :address="address" />
                        </v-card-text>
                    </v-card>

                    <v-card v-for="(subscription, i) in subscriptions" :key="i" class="mb-4">
                        <v-card-title>
                            <span>{{ subscription.plan.name }}</span>
                            <v-spacer></v-spacer>
                            <span class="namePrice">
                                R$ {{ (subscription.items[0].pricing_scheme.price / 100).toLocaleString("pt-BR", {
                                    minimumFractionDigits: 2
                                }) }}
                                <small>/mês</small>
                            </span>
                        </v-card-title>
                        <v-card-text>
                            <v-list class="descPayment mt-0 pt-0">
                                <v-list-item>
                                    Criado em: {{ subscription.created_at | brdatetime }}
                                </v-list-item>
                                <v-list-item>
                                    Próxima cobrança: {{ subscription.next_billing_at | brdate }}
                                </v-list-item>
                                <v-list-item>
                                    Ciclo: {{ subscription.current_cycle.cycle }}
                                </v-list-item>
                                <v-list-item>
                                    Status: <b>{{ subscription.status === `failed` ? `falha no pagamento` :
                                        subscription.status ===
                                            `active` ? `ativo` : subscription.status }}</b>
                                    <v-btn outlined v-if="subscription.status == `failed`" small class="ml-2">Refazer
                                        pagamento</v-btn>
                                </v-list-item>
                                <v-list-item>
                                    {{ subscription.items[0].quantity }} x {{ subscription.items[0].name }} -
                                    {{ (subscription.items[0].quantity * subscription.items[0].pricing_scheme.price /
                                        100).toLocaleString("pt-BR", { minimumFractionDigits: 2 }) }}
                                </v-list-item>
                            </v-list>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn text color="#F15A24" @click="editPlano = true">
                                <v-icon class="mr-1">mdi-plus</v-icon>
                                Adquira mais espaço
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn @click="changePlan = true" text>
                                <v-icon class="mr-1">mdi-refresh</v-icon>
                                Trocar de Plano
                            </v-btn>
                        </v-card-actions>
                        <v-card-actions>
                            <v-btn text class="inter" x-small @click="deleteSubscription(subscription.id)">
                                CANCELAR
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </div>
            </v-col> -->
        </v-row>

        <!-- Dialogs existentes (mantidos) -->
        <v-dialog width="510" v-model="editPlano">
            <v-card>
                <v-card-title>Alterar assinatura</v-card-title>
                <v-card-text>
                    <p>Hoje você utiliza <b>{{ sizeFiles | filesize }}</b> de <b>{{ maxStorage | filesize }}</b>
                        contratados,
                        utilize a barra abaixo para aumentar ou diminuir o tamanho do espaço contratado:</p>
                    <v-slider color="#F15A24" track-color="#00000075" v-model="updatePlan.quantity" thumb-label="always"
                        :min="user.plano == `plano-carreira` ? 10 : 50"
                        :max="user.plano === `plano-carreira` ? 20 : 100"
                        :step="user.plano === `plano-carreira` ? 10 : 50" ticks="always" class="mt-15"></v-slider>
                    <p v-if="subscriptions[0]">
                        Nesta previsão no plano <b>{{ user.plano | plan }}</b> por <b>{{ updatePlan.quantity }}GB</b>
                        será
                        cobrado o valor de
                        <b>R${{ updatePlan.quantity / 10 * (user.plano === `plano-carreira` ? 14.90 : 49.90) }}</b>
                    </p>
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center">
                    <v-btn @click="changeSubscription" :loading="loadingPlano" outlined>Atualizar assinatura</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog width="530" v-model="changePlan">
            <v-card>
                <v-card-title>Trocar de Plano</v-card-title>
                <v-card-text class="d-flex flex-column">
                    <p>Por favor selecione o plano desejado e confirme com o botão abaixo</p>
                    <v-btn-toggle color="#F15A24" class="mx-auto" v-model="planSelected" mandatory>
                        <v-btn x-large height="250px">
                            Plano Carreira <br> 10GiB <br> R$14,90/mês
                        </v-btn>
                        <v-btn x-large height="250px">
                            Plano Premium<br />50GiB <br> R$49,90/mês
                        </v-btn>
                    </v-btn-toggle>
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center">
                    <v-btn @click="changeSubscription" :loading="loadingPlano" outlined>Trocar de Plano</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<style scoped>
/* Estilos existentes mantidos */
.styleSaveButton {
    text-transform: none;
    background-color: #f15a24 !important;
    color: #ffffff;
    margin-top: 20px;
}

.padCols {
    padding: 5px 12px;
}

.icone {
    color: #f15a24;
    margin-right: 8px;
}

.namePayment {
    font-family: Inter;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 0px;
}

.descPayment {
    font-family: Inter;
    font-size: 16px;
    font-weight: 400;
}

.styleBtnEdit {
    padding: 0px 0px !important;
    text-transform: none;
    color: #f15a24;
}

.v-input__prepend-outer {
    margin: 0px !important;
}

/* Estilos para avatar e overlay */
.avatar-container {
    position: relative;
    display: inline-block;
}

.profile-avatar {
    border: 3px solid #ffffff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    overflow: hidden;
}

.avatar-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(241, 90, 36, 0.85);
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    opacity: 0;
    animation: fadeIn 0.3s ease forwards;
}

.avatar-overlay:hover {
    background-color: rgba(241, 90, 36, 0.95);
}

.overlay-text {
    color: white;
    font-size: 12px;
    font-weight: 500;
    margin-top: 4px;
    text-align: center;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

/* Garantir que a imagem do avatar preencha corretamente */
.profile-avatar .v-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>

<!-- Script mantido igual -->
<script>
import PaymentDialog from '../components/PaymentDialog.vue'
export default {
    name: "Perfil",
    components: { PaymentDialog },
    data() {
        return {
            editPlano: false,
            changePlan: false,
            files: [],
            loadingPlano: false,
            updatePlan: { quantity: 1 },
            img: null,
            first_name: this.$store.state.user.first_name,
            nickname: this.$store.state.user.apelido,
            email: this.$store.state.user.email,
            tags: this.$store.state.user.tags,
            local: this.$store.state.user.tags,
            descricao: this.$store.state.user.sobre,

            idNewAvatar: '',
            showInfos: true,
            showEndereco: false,
            showPagamento: false,
            disabledCondition: true,
            editForm: true,
            avatarData: "",
            valid: false,
            avatar: [],
            recentes: [],
            recenteAtivo: 0,
            sizeFiles: 0,
            sizeFilesPercent: 0,
            nameRules: [
                (v) => !!v || "Este campo é obrigatório",
                (v) =>
                    (v && v.length <= 40) || "Nome precisa ter menos de 40 caracteres",
            ],
            emailRules: [
                (v) => !!v || "Email é obrigatório",
                (v) => /.+@.+\..+/.test(v) || "Por favor digite um email válido.",
            ],
            addNewUser: false,
            loadingNewUser: false,
            newUser: {},
            showCapa: false,
            searchUsuarios: "",
            subscriptions: [],
            gerente: {},
            userPerguntas: [],
            userCommentArtigo: [],
            userCommentNoticia: [],
            planSelected: "",
            userCompartilhamentos: [],
            address: {
                id: "",
                cep: "",
                estado: "",
                cidade: "",
                bairro: "",
                rua: "",
                numero: "",
                complemento: ""
            },
            loadingCEP: false
        };
    },
    mounted() {
        this.reloadAvatar();
        //  this.getHistoricoUsuario()
        this.getUserLoggedPayments();
        this.getConsuption();
        this.getAddress()

    },
    computed: {
        maxStorage() {
            let plan = this.user.plano
            switch (true) {
                case (plan == "plano-free"):
                    return 10497800;
                case (["plano-avancado", "plano-carreira", "plan_XV7BG26TbcJoKxYv", "plan_48jmqoxfpH5OzQ0P"].indexOf(plan) >= 0):
                    return 10737418240;
                case (["plano-premium", "plan_3B1DKr3HVqUp8LG5", "plan_vZJkelpIwIyeNq1M"].indexOf(plan) >= 0):
                    return 53687091200;
                case (["plano-legislativo", "plan_g3180ooh6OSo0Wzx"].indexOf(plan) >= 0):
                    return 107374182400; // 100GB
                case (["plan_lay6XlycO4TJw6e1", "plano-patrocinio"].indexOf(plan) >= 0):
                    return 107374182400; // 100GB
                default:
                    return 10497800;
            }
        },
        user() {
            // window.console.log(this.$store.state.user.avatar)
            return this.$store.state.user != undefined
                ? this.$store.state.user
                : { first_name: "Meu Perfil" };
        },
        role() {
            let role = this.$store.state.user.role;
            return role === "c4e091b9-1b89-477e-b7a2-2b37750c84e1"
                ? "admin"
                : role === "df55e59a-150c-4601-acc8-95e29683a39b"
                    ? "user"
                    : null;
            // ? "Administrador"
            // : role === "43a9809b-b893-4015-b424-430ac5a5c380"
            // ? "Editor"
            // : role === "5d9c451e-0195-4b4b-827f-a9935273261d"
            // ? "Leitor"
            // : "Nível de Acesso";
        },
        isGerente() {
            return this.role === "Gerente Relações";
        },
        isUsuario() {
            return this.role === "Usuário" || this.role === "Leitor";
        },
        isAdmin() {
            return this.role === "Administrador";
        },
        filteredUsuarios() {
            if (this.searchUsuarios != null) {
                return this.recentes.filter((item) => {
                    return item.first_name.startsWith(this.searchUsuarios);
                });
            } else {
                return this.recentes;
            }
        },
        intBreakPoint() {
            switch (this.$vuetify.breakpoint.name) {
                case "xs":
                    return 0;
                case "sm":
                    return 1;
                case "md":
                    return 2;
                case "lg":
                    return 3;
                case "xl":
                    return 4;
                default:
                    return 0;
            }
        },
    },
    methods: {
        buscaCEP() {
            let cepStr = this.address.cep;
            this.loadingCEP = true
            if (cepStr != undefined) {
                var cep = cepStr.replace(/\D/g, "");
                //Expressão regular para validar o CEP.
                var validacep = /^[0-9]{8}$/;
                //Valida o formato do CEP.
                if (validacep.test(cep)) {
                    fetch("https://viacep.com.br/ws/" + cep + "/json")
                        .then((response) => response.json())
                        .then((data) => {
                            this.address.cidade = data.localidade;
                            this.address.pais = "BR";
                            this.address.estado = data.uf;
                            this.address.bairro = data.bairro;
                            this.address.rua = data.logradouro;
                            this.loadingCEP = false

                        });
                }
                return cep;
            }
        },
        reloadAvatar(changedAvatar) {
            if (this.user.avatar != null) {
                let time = changedAvatar ? "&timestamp=" + new Date().getTime() : "";
                this.$http({
                    url: "assets/" + this.user.avatar + time,
                    responseType: "blob",
                }).then((response) => {
                    let reader = new FileReader();
                    reader.readAsDataURL(response.data);
                    reader.onload = () => {
                        this.avatarData = reader.result;
                        // x + 1 === comentariosLength ? this.$forceUpdate() : "";
                    };
                });
            } else {
                this.avatarData = require("../assets/icon-person.svg");
            }
        },
        async getUserLoggedPayments() {
            try {
                const { data } = await this.$http.get("payment/subscriptions");

                this.subscriptions = data.filter(
                    (subscription) => subscription.status !== "canceled"
                    // () => true
                );
            } catch (error) {

                // window.console.error(error);
            }
        },
        async deleteSubscription(id) {
            try {
                const deleteConfirm = confirm(
                    "Tem certeza que deseja cancelar sua assinatura?"
                );

                if (!deleteConfirm) {
                    return;
                }

                await this.$http.delete(`payment/subscriptions/${id}`);

                const index = this.subscriptions.findIndex(
                    (subscription) => subscription.id === id
                );
                if (index !== -1) {
                    this.subscriptions.splice(index, 1);
                    this.$http.patch("users/" + this.user.id, { plano: "plano-free" }).then(() => { })
                }
                window.console.error("removido com sucesso");
            } catch (error) {
                window.console.error(error);
            }
        },
        newAvatar() {
            const formData = new FormData();
            formData.append("file", this.files);
            this.$http
                .post("/files", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    if (response.data.data.id === this.user.avatar) {
                        window.alert("Avatar atualizado com sucesso");
                        this.user.avatar = response.data.data.id;
                        this.salvarUsuario();
                        this.reloadAvatar(true);
                    }
                });
        },
        updateAvatar() {
            if (confirm("Você deseja trocar sua foto de perfil ? ")) {
                var formData = new FormData();
                formData.append("file", this.files);
                this.$http
                    .patch("files/" + this.user.avatar, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((response) => {
                        //window.console.log(response)
                        if (response.data.data.id === this.user.avatar) {
                            window.alert("Avatar atualizado com sucesso");
                            this.reloadAvatar(true);
                        }
                    });
            }
        },
        loadAvatarRecentes() {
            // let recentesLength = this.recentes.length
            this.recentes.forEach((p) => {
                if (p.avatar != null) {
                    this.$http({ url: "assets/" + p.avatar, responseType: "blob" }).then(
                        (response) => {
                            let reader = new FileReader();
                            reader.readAsDataURL(response.data);
                            reader.onload = () => {
                                this.avatar[p.id] = reader.result;
                                this.$forceUpdate();
                            };
                        }
                    );
                } else {
                    this.avatar[p.id] = require("../assets/icon-person.svg");
                }
            });
        },
        salvarUsuario() {
            // e.preventDefault();
            this.$http.patch("users/" + this.user.id, this.user).then((response) => {
                if (response.data.data.id == this.user.id) {
                    alert("Usuário salvo com sucesso");
                }
            });
        },
        getConsuption() {
            this.$http({
                //&deep[documento][_aggregate][sum]=filesize
                url: "items/documentos?fields=*,documento.*&filter[id_user][_eq]=" + this.$store.state.user.id + "&filter[status][_eq]=published",
            }).then(
                (res) => {
                    this.arquivos = res.data.data;
                    this.arquivos.map(el => {
                        this.sizeFiles += el.documento.filesize
                        // x = (100 * usado ) / maximo

                        this.sizeFilesPercent = (this.sizeFiles * 100) / this.maxStorage
                    })
                    this.loadingArquivos = false;
                },
                (err) => {
                    window.console.log(err);
                }
            );
        },
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        handleFileSelect(event) {
            const file = event.target.files[0];
            if (file) {
                // Validar tipo de arquivo
                if (!file.type.startsWith('image/')) {
                    alert('Por favor, selecione apenas arquivos de imagem.');
                    return;
                }
                // Validar tamanho (máximo 5MB)
                if (file.size > 5 * 1024 * 1024) {
                    alert('A imagem deve ter no máximo 5MB.');
                    return;
                }
                this.handleImageAdded(file);
            }
            // Resetar o input para permitir selecionar o mesmo arquivo novamente
            event.target.value = '';
        },
        handleImageAdded(file) {
            if (!file) return;
            
            const formData = new FormData();
            formData.append("image", file);
            
            this.$http
                .post("/files", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    this.idNewAvatar = response.data.data.id;
                    let newAvatar = {
                        avatar: this.idNewAvatar
                    };
                    this.$http.patch(`users/${this.$store.state.user.id}`, newAvatar)
                        .then((res) => {
                            // Atualizar o store e recarregar avatar sem recarregar a página
                            this.$store.dispatch("getInfo").then(() => {
                                this.reloadAvatar(true);
                                // Fechar automaticamente o modo de edição após sucesso
                                this.disabledCondition = true;
                                alert("Foto de perfil atualizada com sucesso!");
                            });
                        })
                        .catch((err) => {
                            window.console.error(err);
                            alert("Erro ao atualizar foto de perfil. Tente novamente.");
                        });
                })
                .catch((err) => {
                    window.console.error(err);
                    alert("Erro ao fazer upload da imagem. Tente novamente.");
                });
        },
        handleImageCapa(file) {
            const formData = new FormData();
            formData.append("image", file);
            this.$http
                .post("/files", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    window.console.log(response);
                    this.idNewCapa = response.data.data.id
                    let newCapa = {
                        capa: this.idNewCapa
                    }
                    this.$http.patch(`users/${this.$store.state.user.id}`, newCapa).then((res) => {
                        window.console.log(res)
                        location.reload()
                    }).catch((err) => {
                        window.console.log(err)
                    })
                })
                .catch((err) => {
                    window.console.log(err);
                });
        },
        updateUser() {
            let userUp = {
                first_name: this.first_name,
                email: this.email,
                tags: [this.tags],
                apelido: this.nickname,
                sobre: this.descricao
            }
            this.$http.patch(`/users/${this.$store.state.user.id}`, userUp)
                .then((res) => {
                    window.console.log(res)
                    this.disabledCondition = false
                    this.$store.dispatch("getInfo")
                    alert("Perfil salvo com sucesso")
                    // location.reload()
                }).catch((err) => {
                    window.console.log(err)
                })
        },
        postAddress() {
            let addressUp = {
                cep: this.address.cep,
                estado: this.address.estado,
                cidade: this.address.cidade,
                bairro: this.address.bairro,
                rua: this.address.rua,
                numero: this.address.numero,
                complemento: this.address.complemento
            }
            if (this.address.id == "") {
                this.$http.post(`/items/endereco`, addressUp)
                    .then(() => {
                        alert(`endereço salvo com sucesso`)
                        // window.console.log(res)
                    }).catch((err) => {
                        window.console.log(err)
                    })
            }
            if (this.address.id.length > 0) {
                this.$http.patch(`/items/endereco/${this.address.id}`, addressUp)
                    .then(() => {
                        alert(`endereço salvo com sucesso`)
                        // window.console.log(res)
                    }).catch((err) => {
                        window.console.log(err)
                    })
            }
        },
        getAddress() {
            this.$http.get(`/items/endereco?filter[user_created][_eq]=${this.user.id}`).then((res) => {
                const ends = res.data.data
                if (ends.length > 0) this.address = res.data.data[0]
            })
        },
        async changeSubscription() {
            try {
                this.loadingPlano = true
                await this.$http.post("payment/subscriptions/change",
                    {
                        subscription_id: this.subscriptions[1].id,
                        plan_id: this.user.plano === `plano-carreira` ? `plan_48jmqoxfpH5OzQ0P` : `plan_vZJkelpIwIyeNq1M`,
                        quantity: this.updatePlan.quantity / 10
                    })
                this.getUserLoggedPayments()
                this.editPlano = false
                this.loadingPlano = false
            }
            catch (e) {
                // window.console.log(e)
                this.loadingPlano = false

            }
        }
    },
    filters: {
        plan: function (value) {
            switch (true) {
                case (value === "plano-free"):
                    return "Plano Free";
                case (["plano-avancado", "plano_avancado", "plano-carreira", "plan_XV7BG26TbcJoKxYv", "plan_48jmqoxfpH5OzQ0P"].indexOf(value) >= 0):
                    return "Plano Carreira";
                case (["plano-premium", "plan_3B1DKr3HVqUp8LG5", "plan_vZJkelpIwIyeNq1M"].indexOf(value) >= 0):
                    return "Plano Premium";
                case (["plano-legislativo", "plan_g3180ooh6OSo0Wzx"].indexOf(value) >= 0):
                    return "Plano Legislativo";
                case (["plano-patrocinio", "plan_lay6XlycO4TJw6e1"].indexOf(value) >= 0):
                    return "Plano Patrocínio";
                default:
                    return "Plano Free";
            }
        }
    }
};
</script>
